import { useEffect, useRef, useState } from "react";

export const scrollLeftBy = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  scrollBy: number
) => {
  if (ref.current) {
    ref.current.scrollTo({ left: ref.current.scrollLeft + scrollBy, behavior: "smooth" });
  }
};

export const useScrollHelper = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [scrollInterval, setScrollInterval] = useState<NodeJS.Timer | null>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const onMouseDown = (direction: "left" | "right") => {
    const i = setInterval(() => {
      if (ref.current && !scrollInterval) {
        const maxWidth = (ref?.current?.scrollWidth ?? 0) - (ref?.current?.offsetWidth ?? 100) - 10;
        if (direction === "left" && ref.current.scrollLeft > 0) {
          scrollLeftBy(ref, -300);
        }

        if (direction === "right" && ref.current.scrollLeft < maxWidth) {
          scrollLeftBy(ref, +300);
        }
      }
    }, 100);

    setScrollInterval(i);
  };
  const onMouseUp = () => {
    if (scrollInterval) {
      clearInterval(scrollInterval as unknown as number);
      setScrollInterval(null);
    }
  };
  useEffect(() => {
    if (ref.current) {
      ref.current
        ?.querySelector("button[aria-label='Show path']")
        ?.addEventListener("click", () => {
          setIsExpanded(true);
        });

      const maxWidth = (ref?.current?.scrollWidth ?? 0) - (ref?.current?.offsetWidth ?? 100);
      if (ref.current?.scrollLeft < 10 || ref.current.scrollLeft >= maxWidth) {
        onMouseUp();
      }

      setShowRightArrow(
        isExpanded &&
          (ref.current.scrollLeft < maxWidth || ref.current.offsetWidth >= ref.current.scrollWidth)
      );

      setShowLeftArrow(ref.current.scrollLeft >= 10);
    }
  }, [ref.current?.scrollLeft, ref.current?.offsetWidth, ref.current?.scrollWidth]);
  return { ref, onMouseDown, onMouseUp, showLeftArrow, showRightArrow };
};
